export const kilometersToMiles = kilometers => {
  const conversionFactor = 0.621371; // 1 kilometer = 0.621371 miles
  return (kilometers * conversionFactor).toFixed(2);
};

export const milesToKilometers = miles => {
  const conversionFactor = 1.60934; // 1 mile = 1.60934 kilometers
  return (miles * conversionFactor).toFixed(2);
};

export const metersToFeet = meters => {
  const conversionFactor = 3.28084; // 1 meter = 3.28084 feet
  return (meters * conversionFactor).toFixed();
};

export const feetToMeters = feet => {
  const conversionFactor = 0.3048; // 1 foot = 0.3048 meters
  return (feet * conversionFactor).toFixed(2);
};

export const convertDistance = (place, platformLocation) => {
  if (platformLocation === 'US') {
    if (place.parameters.unit === 'm') {
      place.parameters.distance = metersToFeet(place.parameters.distance);
    } else if (place.parameters.unit === 'km') {
      place.parameters.distance = kilometersToMiles(place.parameters.distance);
    }
  }
  return place;
};
